import {FormEnvironment} from "@fd/Types.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";

export default async function (env:FormEnvironment, srcType:number, srcId:number|string):Promise<boolean> {
	const ns = useNavigationStore();
	let ep = "api/worksheets/start-tracking";
	ep = env.net.urlParam(ep, "srcType", srcType);
	ep = env.net.urlParam(ep, "srcId", srcId);
	const resp = await env.net.fetch(ep);
	return resp.ok;
}